export default "__VITE_ASSET__DkJmrlMb__"